import React, { useState } from 'react';
import { SearchIcon, CameraIcon, StarIcon, MapPinIcon, FilterIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface Photographer {
  id: number;
  name: string;
  location: string;
  specialties: string[];
  rating: number;
  reviewCount: number;
  imageUrl: string;
  portfolioUrl: string;
  availability: string;
  priceRange: string;
}
const photographers: Photographer[] = [{
  id: 1,
  name: 'Sarah Chen',
  location: 'New York, NY',
  specialties: ['Author Portraits', 'Book Covers', 'Editorial'],
  rating: 4.9,
  reviewCount: 124,
  imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330',
  portfolioUrl: '/portfolio/sarah-chen',
  availability: 'Available Now',
  priceRange: '$500-1000'
}, {
  id: 2,
  name: 'Marcus Rodriguez',
  location: 'Los Angeles, CA',
  specialties: ['Fashion', 'Book Covers', 'Commercial'],
  rating: 4.8,
  reviewCount: 98,
  imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d',
  portfolioUrl: '/portfolio/marcus-rodriguez',
  availability: 'Available from June',
  priceRange: '$750-1500'
}, {
  id: 3,
  name: 'Emma Wilson',
  location: 'London, UK',
  specialties: ['Author Portraits', 'Events', 'Editorial'],
  rating: 4.7,
  reviewCount: 86,
  imageUrl: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80',
  portfolioUrl: '/portfolio/emma-wilson',
  availability: 'Limited Availability',
  priceRange: '$1000-2000'
}
// Add more photographers as needed
];
const Photographers = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSpecialty, setSelectedSpecialty] = useState('All');
  const specialties = ['All', 'Author Portraits', 'Book Covers', 'Editorial', 'Fashion', 'Events', 'Commercial'];
  const filteredPhotographers = photographers.filter(photographer => {
    const matchesSearch = photographer.name.toLowerCase().includes(searchTerm.toLowerCase()) || photographer.location.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesSpecialty = selectedSpecialty === 'All' || photographer.specialties.includes(selectedSpecialty);
    return matchesSearch && matchesSpecialty;
  });
  return <div className="min-h-screen bg-gray-50 py-8" data-id="element-14928" data-mp="1a1ooza6sulej">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14929" data-mp="19z2ep2sixrsm">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-14930" data-mp="1e27e2whb5dd1">
          <CameraIcon className="h-12 w-12 text-purple-600 mx-auto mb-4" data-id="element-14931" data-mp="1j1k4fr7e12kd" />
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-14932" data-mp="1izh2q9wvhkzt">
            Find Your Perfect Photographer
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-14933" data-mp="1srdcii8bmzjv">
            Connect with professional photographers specializing in author
            portraits and book cover photography
          </p>
        </div>
        {/* Search and Filter */}
        <div className="mb-8 flex flex-col sm:flex-row gap-4" data-id="element-14934" data-mp="21sunxnasad28">
          <div className="relative flex-1" data-id="element-14935" data-mp="3mam1myntf76s">
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-14936" data-mp="3mbop0wlxirhy" />
            <input type="text" placeholder="Search by name or location..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-14937" data-mp="3ib4vs44h8813" />
          </div>
          <div className="relative" data-id="element-14938" data-mp="4udynh4saakn">
            <FilterIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-14939" data-mp="35ogivmql6f" />
            <select className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent appearance-none bg-white" value={selectedSpecialty} onChange={e => setSelectedSpecialty(e.target.value)} data-id="element-14940" data-mp="3r9q9nlz06yvj">
              {specialties.map(specialty => <option key={specialty} value={specialty} data-id="element-14941" data-mp="895ihmnjblko">
                  {specialty}
                </option>)}
            </select>
          </div>
        </div>
        {/* Photographers Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-14942" data-mp="3uk1bj7h7xkni">
          {filteredPhotographers.map(photographer => <div key={photographer.id} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-14943" data-mp="r0ohzjicohhy">
              <img src={photographer.imageUrl} alt={photographer.name} className="w-full h-48 object-cover" data-id="element-14944" data-mp="vzro77a2gtri" />
              <div className="p-6" data-id="element-14945" data-mp="m9py69y5l19y">
                <div className="flex justify-between items-start mb-2" data-id="element-14946" data-mp="m8nasc01hgys">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-14947" data-mp="19z10vwz2d5qq">
                    {photographer.name}
                  </h3>
                  <div className="flex items-center" data-id="element-14948" data-mp="1esvjex2xneo8">
                    <StarIcon className="h-5 w-5 text-yellow-400" data-id="element-14949" data-mp="2zgek0vlombtj" />
                    <span className="ml-1 text-sm text-gray-600" data-id="element-14950" data-mp="2ui4noho8156c">
                      {photographer.rating}
                    </span>
                  </div>
                </div>
                <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-14951" data-mp="38bcck1kx3mkc">
                  <MapPinIcon className="h-4 w-4 mr-1" data-id="element-14952" data-mp="348ps4lqkt3x6" />
                  {photographer.location}
                </div>
                <div className="mb-4" data-id="element-14953" data-mp="2gk6jg53m6p4k">
                  <div className="flex flex-wrap gap-2" data-id="element-14954" data-mp="2bk0oaey4ykhq">
                    {photographer.specialties.map(specialty => <span key={specialty} className="px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded-full" data-id="element-14955" data-mp="2pkl73b41wgb8">
                        {specialty}
                      </span>)}
                  </div>
                </div>
                <div className="flex items-center justify-between text-sm mb-4" data-id="element-14956" data-mp="3w16p0i1br942">
                  <span className="text-green-600" data-id="element-14957" data-mp="2tl63nruqyh7t">
                    {photographer.availability}
                  </span>
                  <span className="text-gray-600" data-id="element-14958" data-mp="2ymlr1qkecztd">
                    {photographer.priceRange}
                  </span>
                </div>
                <div className="flex gap-2" data-id="element-14959" data-mp="37lpch171drb1">
                  <button className="flex-1 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors" data-id="element-14960" data-mp="37jcuio1a3gxz">
                    Contact
                  </button>
                  <Link to={`/talent/photographers/${photographer.id}/portfolio`} className="flex-1 border border-purple-600 text-purple-600 px-4 py-2 rounded-lg hover:bg-purple-50 transition-colors text-center" data-id="element-14961" data-mp="2exbeglfy6uzh">
                    View Portfolio
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};
export default Photographers;